import { render } from "./StockOrBack.vue?vue&type=template&id=d532ceb6&scoped=true"
import script from "./StockOrBack.vue?vue&type=script&lang=js"
export * from "./StockOrBack.vue?vue&type=script&lang=js"

import "./StockOrBack.vue?vue&type=style&index=0&id=d532ceb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d532ceb6"]])

export default __exports__